import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { CanActivate, Router } from '@angular/router';
import { firstValueFrom, Observable, of, switchMap, take } from 'rxjs';
import { map } from 'rxjs';
import { UserService } from '../../core/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router,
    private userService: UserService) { }

  async canActivate(): Promise<boolean> {
    // let isAuthenticated = false;
    let tokenInfo: any = {};

    let suscription: any = null;
    const result = new Promise<boolean>((resolve, reject) => {
      suscription = this.auth.isLoading$.subscribe(async (value) => {

        if (!value) {

          if (suscription)
            suscription.unsubscribe();

          const hasValid = this.userService.hasTokenValid();

          if (hasValid) {
            const previousToken = localStorage.getItem("token_data");
            const tokenData = JSON.parse(previousToken!);
            if (tokenData.expiration) {
              const expirationDate = new Date(tokenData.expiration);
              const currentDate = new Date();
              if (expirationDate > currentDate) {
                this.userService.setTokenSubject(tokenData.token);
                resolve(true);
                return;
              }
            }

          }


          const isAuth = await firstValueFrom(this.auth.isAuthenticated$);

          if (!isAuth) {

            resolve(false);
            this.router.navigate(['/login']);
            return;
          }

          const userData = await firstValueFrom(this.auth.user$);
          if (userData) {
            localStorage.setItem('user_data', JSON.stringify({ ...userData }));
          }

          const token = await firstValueFrom(this.auth.getAccessTokenSilently());
          if (!token) {
            resolve(false);
            this.router.navigate(['/login']);
            return;
          }

          tokenInfo.access_token = token;


          const idTokenClaims = await firstValueFrom(this.auth.idTokenClaims$);

          if (!idTokenClaims) {

            resolve(false);
            this.router.navigate(['/login']);
            return;
          }

          tokenInfo.company = localStorage.getItem('companyName') ?? 'No disponible';
          tokenInfo.id_token = idTokenClaims?.__raw;
          tokenInfo.scope = 'openid profile email';
          tokenInfo.expires_in = 86400;

          localStorage.setItem("token_id", idTokenClaims?.__raw);

          const res = await firstValueFrom(this.userService.getToken(tokenInfo));

          if (!res) {

            resolve(false);
            this.router.navigate(['/login']);
            return;
          }

          if (res?.token) {

            resolve(true);
          } else {

            resolve(false);
            this.router.navigate(['/login']);
          }
        }
      })

    })

    return result;

  }
}
